module.exports = __webpack_public_path__ + "img/review_btn.626dfa98.png";